import * as React from 'react';

import loadable from '@loadable/component';

import { WishlistSkeleton } from './components/WishlistPage/WishlistSkeleton';

export default loadable(() => import('../WishList'), {
  fallback: <WishlistSkeleton />,
});
